import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide, } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/navigation';

import { Pagination, Navigation } from "swiper";
import SwiperCore, { Autoplay } from "swiper";
import FrankfurtLogo from "../assets/collaboration/frankfurt.png";
import MelezLogo from "../assets/logo-section/melez.png";
import EmekLogo from "../assets/logo-section/emek.png";
import MidasLogo from "../assets/logo-section/midas.png";
import KoppertLogo from "../assets/logo-section/koppert.png";
import languageStorage from "../lang/findLanguage";

// import Avatar from "../assets/avatar.webp";

SwiperCore.use([Autoplay]);

export default function SlideItems({ language }) {
  const swiperRef = useRef();
  const [companies] = useState([
    {
      id: 1,
      company: "Melez Tea",
      logo: MelezLogo,
      description: [
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[0].k0001 : language[1].sections[12].keys[0].k0001}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[1].k0002 : language[1].sections[12].keys[1].k0002}</p>`,
      ],
      user: "Emre Aslanoba",
      title: "CEO",
    },
    {
      id: 2,
      company: "Emek Yağ",
      logo: EmekLogo,
      description: [
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[2].k0003 : language[1].sections[12].keys[2].k0003}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[3].k0004 : language[1].sections[12].keys[3].k0004}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[4].k0005 : language[1].sections[12].keys[4].k0005}</p>`,
      ],
      user: "Özlen Ernez",
      title: `${languageStorage() === "tr" ? language[0].sections[12].keys[5].k0006 : language[1].sections[12].keys[5].k0006}`,
    },
    {
      id: 3,
      company: "Frankfurt School",
      logo: FrankfurtLogo,
      description: [
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[6].k0007 : language[1].sections[12].keys[6].k0007}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[7].k0008 : language[1].sections[12].keys[7].k0008}</p>`,
      ],
      user: "Koray Alus",
      title: `${languageStorage() === "tr" ? language[0].sections[12].keys[8].k0009 : language[1].sections[12].keys[8].k0009}`,
    },
    {
      id: 4,
      company: "Midas",
      logo: MidasLogo,
      description: [
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[9].k0010 : language[1].sections[12].keys[9].k0010}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[10].k0011 : language[1].sections[12].keys[10].k0011}</p>`,
        `<p>${languageStorage() === "tr" ? language[0].sections[12].keys[11].k0012 : language[1].sections[12].keys[11].k0012}</p>`,
      ],
      user: "Cihad Akın",
      title: `${languageStorage() === "tr" ? language[0].sections[12].keys[14].k0015 : language[1].sections[12].keys[14].k0015}`,
    },
    {
      id: 5,
      company: "Koppert",
      logo: KoppertLogo,
      description: [`<p>${languageStorage() === "tr" ? language[0].sections[12].keys[12].k0013 : language[1].sections[12].keys[12].k0013}</p>`],
      user: "Mehmet Bulut",
      title: `${languageStorage() === "tr" ? language[0].sections[12].keys[13].k0014 : language[1].sections[12].keys[13].k0014}`,
    },
  ]);

  const onInit = (Swiper) => (swiperRef.current = Swiper);
  const handleMouseEnter = () => swiperRef.current && swiperRef.current.autoplay.stop();
  const handleMouseLeave = () => swiperRef.current && swiperRef.current.autoplay.start();

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Swiper
        onInit={onInit}
        slidesPerView={4}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 5000,
          autoplayDisableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]} // add Navigation module here
        navigation={true}
        className="mySwiper"
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          991: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        }}
      >
        {companies.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="slide-item">
              <label>{item.company}</label>
              <img
                src={item.logo}
                className="slide-item-img img-fluid"
                width="140"
                height="60"
                alt=""
              />
              <div className="slide-description">
                {item.description.map((text, index) => (
                  <p
                    key={index}
                    className="slide-item-text"
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  ></p>
                ))}
              </div>
              <div className="user d-flex align-items-center">
                {/* <img src={Avatar} className="avatar" alt="Avatar" width="60" height="60"></img> */}
                <div className="user-info">
                  <p className="username">{item.user}</p>
                  <p className="user-title">{item.title}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-button-prev" onClick={() => swiperRef.current.slidePrev()}></div>
        <div className="swiper-button-next" onClick={() => swiperRef.current.slideNext()}></div>
      </Swiper>
    </div>
  );
}
